/**
 * What a rejected Desktop IPC call actually said, without the wrapping it picked up on the way.
 *
 * Electron prefixes a rejected IPC call with the channel name, and the desktop's tagged error
 * prefixes its own class name; neither means anything to the person reading it.
 */
export function desktopIpcFailureDetail(cause: unknown): string {
  const raw = cause instanceof Error ? cause.message : String(cause);
  return raw
    .replace(/^Error invoking remote method '[^']*':\s*/u, "")
    .replace(/^[A-Z][A-Za-z]*Error:\s*/u, "")
    .trim();
}
